module.exports = __webpack_public_path__ + "static/media/box-printing.41c968fe.JPG";